export default __webpack_public_path__ + "static/mexicoach_logo-ad29ac61574e2833de8905cb0ed138ae.png";